import { AUTH_COOKIE as COMMON_AUTH_COOKIE } from "../../../@common/constants/StorageKeys";

const KEY_PREFIX = "tyoluvat-app";
const makeStorageKey = (...args: string[]) => [KEY_PREFIX, ...args].join("__");

export const AUTH_COOKIE = COMMON_AUTH_COOKIE; //  makeStorageKey("sid");
export const PREV_LOCATION = makeStorageKey("PrevLocation", "path");

export const PERMITS_FILTERS = makeStorageKey("filters")
export const PERMIT_PAGINATION = makeStorageKey("pagination");

export const PERMIT_LIST_PAGE_SIZE = makeStorageKey("permitList-page-size")
export const ARCHIVE_PAGE_SIZE = makeStorageKey("archive-page-size")


export const PERMIT_EDITS = makeStorageKey("permit-edits");
export const PERMIT_TASK_EDITS = makeStorageKey("permit-task");



export const clearLocalStorage = () => {
    localStorage.removeItem(PERMITS_FILTERS);
    localStorage.removeItem(PERMIT_PAGINATION);
    localStorage.removeItem(PERMIT_EDITS);
    localStorage.removeItem(PERMIT_TASK_EDITS);
};